import assetPath from '/app/packages/video/video-upload/src/assets/upload.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')